import { PLATFORMS } from '../constants';

const { ACCOUNTS } = PLATFORMS;

export const ACCOUNT_SETTINGS_LINK = `${ACCOUNTS}/dashboard/profile/`;
export const PRACTICE_SETTINGS_LINK = `${ACCOUNTS}/dashboard/practices/`;
export const SUPPORT_LINK =
  'https://witmetrics.atlassian.net/servicedesk/customer/portals';
